// Web Storage that can never throw. Browsers break storage at three points:
// the window.localStorage GETTER itself (Chrome "Block all cookies",
// enterprise policies), setItem (Safari private mode, quota), and any call
// mid-session once quota/policy changes. A translator page or a diagnostics
// page must degrade, not die, so every access here is guarded.
//
// `persistent` tells callers which world they got: false means values only
// live until the next reload (in-memory stub) — the debug autorun guard uses
// that to refuse blind re-runs it could never detect.
export function safeStorage(kind) {
  let real;
  try {
    real = window[`${kind}Storage`];
    const probe = 'moxhi.storage.probe';
    real.setItem(probe, '1');
    real.removeItem(probe);
  } catch {
    const mem = new Map();
    return {
      persistent: false,
      getItem: (k) => mem.get(k) ?? null,
      setItem: (k, v) => { mem.set(k, String(v)); },
      removeItem: (k) => { mem.delete(k); },
    };
  }
  return {
    persistent: true,
    getItem: (k) => { try { return real.getItem(k); } catch { return null; } },
    setItem: (k, v) => { try { real.setItem(k, v); } catch { /* best effort */ } },
    removeItem: (k) => { try { real.removeItem(k); } catch { /* best effort */ } },
  };
}
